module.exports = {"date":"Date","invoiceValue":"Value Invoice","invoiceNumber":"Invoice Number","content":"Content","vat":"VAT","vendorName":"Vendor Name","taxCode":"Tax Code"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/no/invoice.json
// module id = Ty0T
// module chunks = 23